/* eslint-disable no-console */

const host = typeof window !== 'undefined' ? window.location.hostname : ''; // Get current hostname
const TEST_ENV_HOST = 'tdoctest.com';

const UpdateUrl = (url, {fePrefix = false}) => {
    if (typeof url !== 'string' || !url.startsWith('http')) {
        console.warn('Invalid URL provided:', url);

        return '';
    }

    let updatedUrl;
    let serviceName; // Extract the service name from the URL

    try {
        if (url?.includes('-ccmpreprod')) {
            // Case 1: Extract everything before -ccmpreprod
            const match = url.match(
                /https?:\/\/([^.-]+(?:-[^.-]+)*)-ccmpreprod/
            );

            serviceName = match ? match[1] : null;
        }

        if (serviceName) {
            const updatedHostname = host.replace(/^(my)/, `${serviceName}`);

            // Construct the final URL
            updatedUrl = url.replace(
                /https?:\/\/[^\/]+/,
                `https://${updatedHostname}`
            );

            // Custom replacements for specific URLs
            updatedUrl = updatedUrl.replace('program', 'fe-upsell');
            updatedUrl = updatedUrl.replace('education', 'fe-remonj');

            // If enabled, add "fe-" in front of the domain
            if (fePrefix) {
                updatedUrl = updatedUrl.replace(
                    /https:\/\/([^/]+)/,
                    'https://fe-$1'
                );
            }

            return updatedUrl;
        } else {
            return url;
        }
    } catch (error) {
        console.warn('Error updating URL:', url, error);

        return url;
    }
};

/**
 * Determines to get the correct URL based on the environment.
 * - Uses process.env value in Development or Production or Preprod(legacy).
 * - Calls UpdateUrl() if in EOD's.
 */
const getEnvUrl = (envValue, options = {}) => {
    const {fePrefix = false} = options;

    // If envValue is empty/null/undefined, just return it directly.
    if (!envValue) return envValue;

    try {
        if (
            host.includes(TEST_ENV_HOST) &&
            window?.ENV?.CCM_ENABLED &&
            process.env.ENVIRONMENT !== 'local'
        ) {
            return UpdateUrl(envValue, {fePrefix});
        } else {
            // If we are not in the test environment, just return the envValue
            return envValue;
        }
    } catch (error) {
        console.error('Error resolving ENV for URL:', error);
    }

    return envValue;
};

export const API_URL = getEnvUrl(process.env.API_URL);
export const SERVICE_URL = getEnvUrl(process.env.SERVICE_URL);
export const REGISTER_URL = getEnvUrl(process.env.REGISTER_URL);
export const SIGNUP_URL = getEnvUrl(process.env.SIGNUP_URL);
export const UPSELL_URL = getEnvUrl(process.env.UPSELL_URL);
export const COACHING_URL = getEnvUrl(process.env.COACHING_URL, {
    fePrefix: true,
});
export const EDUCATION_URL = getEnvUrl(process.env.EDUCATION_URL);
export const MYSTRENGTH_URL = getEnvUrl(process.env.MYSTRENGTH_URL);
export const MYSTRENGTH_API_URL = getEnvUrl(process.env.MYSTRENGTH_API_URL);
export const REDIRECT_GOTO = getEnvUrl(process.env.REDIRECT_GOTO);
